import { sanitize } from 'dompurify';

export function getSanitizedText(text: string) {
  return sanitize(text);
}
